<template>
    <stars
        :rating="getCardStarsCount"
        :size="size"
        :align="align"
    />
</template>

<script>
import Stars from '@/components/Stars.vue';
export default {
    components: {
        Stars
    },
    props: {
        card: {
            type: Object,
            required: true,
            default: () => {}
        },
        size: {
            type: String,
            required: false,
            default: 'md'
        },
        align: {
            type: String,
            required: false,
            default: 'center'
        }
    },
    computed: {
        getCardStarsCount() {
            if (this.card.data.overwrite_stars) {
                return Number(this.card.data.overwrite_stars);
            }
            return Number(Math.round(this.card.data.core_api.ratings.average_score));
        }
    }
};
</script>